var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"policy-and-documents"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-default-12"},[_c('div',{staticClass:"html-content",domProps:{"innerHTML":_vm._s(_vm.text)}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-default-12"},[_c('documents',{attrs:{"source":_vm.documents}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }